import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const UserAuthCtx = createContext(null);

export function UserAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("kha_user_token");
    if (!t) {
      setLoading(false);
      return;
    }
    api
      .get("/users/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("kha_user_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (identifier, password) => {
    const r = await api.post("/users/login", { identifier, password });
    localStorage.setItem("kha_user_token", r.data.token);
    setUser(r.data.user);
    return r.data;
  };

  const register = async (data) => {
    const r = await api.post("/users/register", data);
    localStorage.setItem("kha_user_token", r.data.token);
    setUser(r.data.user);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("kha_user_token");
    setUser(null);
  };

  // Used by OAuth callback: server already validated and issued a JWT.
  const setSessionFromServer = useCallback((token, u) => {
    if (!token) return;
    localStorage.setItem("kha_user_token", token);
    setUser(u || null);
  }, []);

  return (
    <UserAuthCtx.Provider value={{ user, login, register, logout, loading, setSessionFromServer }}>
      {children}
    </UserAuthCtx.Provider>
  );
}

export const useUserAuth = () => useContext(UserAuthCtx);
